define('glu/grid/header/tableHeaderLayout',['require','../../layout','hbs!./tableHeaderLayout.hbs'],function(require) {
    'use strict';

    var Layout = require('../../layout'),
        tpl = require('hbs!./tableHeaderLayout.hbs');

    /*
     * Layout for standard table header.  Currently includes regions for filters,
     * badges, and aux controls but can easily be adapted for additional regions.
     */
    return Layout.extend({
        template: tpl,

        setFilters: function(view) {
            this.filtersView = view;
        },

        setFilterBadges: function(view) {
            this.filterBadgesView = view;
        },

        setFilterBadgeHeader: function(view) {
            this.filterBadgeHeaderView = view;
        },

        setPager: function(view) {
            this.pagerView = view;
        },

        setSavedViews: function(view) {
            this.savedViewsView = view;
        },

        setToggleButtons: function(view) {
            this.toggleButtonsView = view;
        },

        setMultiColumnSort: function(view) {
            this.multiColumnSortView = view;
        },

        onRender: function() {
            if (this.filtersView) {
                this.filters.show(this.filtersView);
            }

            if (this.filterBadgesView) {
                this.filterBadges.show(this.filterBadgeHeaderView);
            }

            if (this.pagerView) {
                this.pager.show(this.pagerView);
            }

            if (this.savedViewsView) {
                this.savedViews.show(this.savedViewsView);
            }

            if (this.toggleButtonsView) {
                this.toggleButtons.show(this.toggleButtonsView);
            }

            if (this.multiColumnSortView) {
                this.multiColumnSort.show(this.multiColumnSortView);
            }
        }
    });
});

